import React, { memo } from 'react';

import clsx from 'clsx';

import { DoneIcon, HourglassIcon, UploadIcon } from 'components/common/Icons/Icons';
import { Status } from 'components/applications/applications.enums';

import styles from './DocumentDropzoneArea.module.scss';
import { ButtonStatus } from './documentDropzoneArea.enums';

interface UploadAreaProps {
  status?: Status | null;
  isAdditionalUploadAllowed?: boolean;
  isDragActive?: boolean;
}

const DocumentDropzoneArea = memo(
  ({ status = Status.Upload, isAdditionalUploadAllowed = true, isDragActive = false }: UploadAreaProps) => {
    switch (true) {
      case status === Status.Upload:
        return (
          <div className={clsx(styles.uploadType, { [styles.dragActive]: isDragActive })}>
            <UploadIcon />
            <p>{ButtonStatus.Upload}</p>
          </div>
        );
      case status === Status.Confirmed:
        return (
          <div className={styles.completedType}>
            <DoneIcon />
            <p>{ButtonStatus.Completed}</p>
          </div>
        );
      case status === Status.Pending && isAdditionalUploadAllowed:
        return (
          <div className={clsx(styles.pendingWithAdditionalUploadType, { [styles.dragActive]: isDragActive })}>
            <span className={styles.pendingWithAdditionalIconContainer}>
              <HourglassIcon className={styles.hourGlassIcon} />
              Received
            </span>
            <p className={styles.textButton}>Upload Additional Files</p>
          </div>
        );
      case status === Status.Pending && !isAdditionalUploadAllowed:
        return (
          <div className={styles.pendingType}>
            <HourglassIcon />
            Received
          </div>
        );
      default:
        return (
          <div className={clsx(styles.uploadType, { [styles.dragActive]: isDragActive })}>
            <UploadIcon />
            <p>{ButtonStatus.Upload}</p>
          </div>
        );
    }
  },
);

export default DocumentDropzoneArea;
